import React, { useState, useEffect } from 'react';
import { Button, Menu, Typography, Avatar } from 'antd';
import { Link } from 'react-router-dom';
import { HomeOutlined, MoneyCollectOutlined, BulbOutlined, FundOutlined, MenuOutlined } from '@ant-design/icons';
import icon from '../images/cryptocurrencies.jpg';

const Navbar = () => {
    const [activeMenu, setActiveMenu] = useState(true);
    const [screenSize, setScreenSize] = useState(undefined);

    useEffect(() => {
        const handleResize = () => setScreenSize(window.innerWidth);

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (screenSize <= 800) {
            setActiveMenu(false);
        } else {
            setActiveMenu(true);
        }
    }, [screenSize]);

    const navContainerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#000',
        color: '#fff',
        padding: '1rem',
        fontFamily: '"Roboto Mono", monospace',
    };

    const logoContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: '1200px',
    };

    const logoStyle = {
        marginLeft: '1rem',
        color: '#fff',
    };

    const menuControlContainerStyle = {
        display: screenSize <= 800 ? 'block' : 'none',
        color: '#fff',
    };

    const menuStyle = {
        width: '100%',
        maxWidth: '1200px',
        border: 'none',
    };

    const menuItemStyle = {
        color: '#fff',
    };

    const menuItemLinkStyle = {
        color: '#fff',
    };

    const menuItemHoverStyle = {
        backgroundColor: '#333',
    };

    return (
        <div style={navContainerStyle}>
            <div style={logoContainerStyle}>
                <Avatar src={icon} size="large" />
                <Typography.Title level={2} style={logoStyle}>
                    <Link to="/" style={menuItemLinkStyle}>𝗖𝗿𝘆𝗽𝘁𝗼𝗨𝗻𝗶𝘃𝗲𝗿𝘀𝗲</Link>
                </Typography.Title>
                <Button style={menuControlContainerStyle} onClick={() => setActiveMenu(!activeMenu)}>
                    <MenuOutlined />
                </Button>
            </div>
            {activeMenu && (
                <Menu theme="dark" style={menuStyle}>
                    <Menu.Item icon={<HomeOutlined />} style={menuItemStyle}>
                        <Link to="/" style={menuItemLinkStyle}>𝙃𝙤𝙢𝙚</Link>
                    </Menu.Item>
                    <Menu.Item icon={<FundOutlined />} style={menuItemStyle}>
                        <Link to="/cryptocurrencies" style={menuItemLinkStyle}>𝘾𝙧𝙮𝙥𝙩𝙤𝙘𝙪𝙧𝙧𝙚𝙣𝙘𝙞𝙚𝙨</Link>
                    </Menu.Item>
                    <Menu.Item icon={<MoneyCollectOutlined />} style={menuItemStyle}>
                        <Link to="/exchanges" style={menuItemLinkStyle}>𝙀𝙭𝙘𝙝𝙖𝙣𝙜𝙚𝙨</Link>
                    </Menu.Item>
                    <Menu.Item icon={<BulbOutlined />} style={menuItemStyle}>
                        <Link to="/news" style={menuItemLinkStyle}>𝙉𝙚𝙬𝙨</Link>
                    </Menu.Item>
                </Menu>
            )}
        </div>
    );
};

export default Navbar;
